import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AgreementContactUs } from "@shared/models/agreement-contact-us.model";
import { RequestType } from "@shared/models/request-types.model";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-contact-reference-request",
  standalone: true,
  imports: [DropdownModule, TranslateModule, CommonModule, ReactiveFormsModule],
  templateUrl: "./contact-reference-request.component.html",
})
export class ContactReferenceRequestComponent {
  @Input() memberAgreements!: AgreementContactUs[];
  @Input() requestNatureOptions!: RequestType[];
  @Input() form!: FormGroup;

  @Output() referenceChange = new EventEmitter<void>();
  @Output() requestNatureChange = new EventEmitter<void>();

  /**
   * Emits an event when the selected reference changes.
   */
  onSelectReference() {
    this.referenceChange.emit();
  }

  /**
   * Emits an event when the selected request nature changes.
   */
  onSelectNatureDemand() {
    this.requestNatureChange.emit();
  }
}
